import src from "IMAGE";
export default { src, width: 180, height: 66, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/webp;base64,UklGRlQAAABXRUJQVlA4TEcAAAAvB4AAAM1VICICHggwDQAAAICPByAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8FI9twAAABGRXI3dA3o+m6hbn6JHAQA="};
